import * as X from "@/ui";

import NotFoundImage from "@/ui/shared/assets/error-404.svg";


export function ErrorPage(props: {
  type: "notFound" | "runtimeError";
}) {
  const tr = X.useTranslator();

  return (
    <div className="max-w-2xl mx-mobile-margin xl:mx-auto h-svh flex flex-col gap-8 justify-center items-center py-4">
      <h1 className="text-[48px] xl:text-[96px] font-medium leading-tight">
        {tr({
          en: `Oooops!`,
          fr: `Oooops${X.Nbsp}!`
        })}
      </h1>

      {props.type === "notFound" && (
        <X.Image
          src={NotFoundImage}
          alt="404"
          className="w-full h-auto mt-2 mb-4"
        />
      )}

      <p className="text-[20px] xl:text-[24px] font-medium mb-2">
        {X.matchKey(props.type, {
          "notFound": () => tr({
            en: "Page not found",
            fr: "Page introuvable",
          }),
          "runtimeError": () => tr({
            en: "Something went wrong…",
            fr: "Quelque chose s'est mal passé…",
          }),
        })}
      </p>

      <X.Button
        secondary lg
        href="/"
        label={tr({
          en: "Go to the home page",
          fr: "Aller à la page d'accueil",
        })}
      />
    </div>
  );
}
